// import { USER_LOGIN_LOADING, USER_LOGIN_SUCCESS, USER_LOGIN_ERROR } from "../../../constant/actionTypes";
import { GET_SEASON_LOADING, GET_SEASON_SUCCESS, GET_SEASON_ERROR } from "../../../constant/actionTypes";

const getSeasonReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_SEASON_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case GET_SEASON_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_SEASON_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default getSeasonReducer;